export default "__VITE_ASSET__CwTWxYEs__"